


















import { DecomojiViewModel } from "@/store/modules/decomoji/models";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component
export default class App extends Vue {
  /**
   * UIストアの viewModel を引き当てる
   */
  @Getter("decomoji/viewModel") decomoji!: DecomojiViewModel;
}
